import { FC } from 'react';
import { Link } from '@chakra-ui/react';

import Callout from 'components/_core/Callout';
import useGetMigrationToEpData from 'features/Bank/pages/Overview/Transactions/hooks/useGetMigrationToEPData';
import { formatDate } from 'helpers/date';
import { getEstimatedEPMigrationEndDate } from 'helpers/epMigration';

import locales from './locales';

const UPDATE_DIRECT_DEBIT_MANDATE_HELP_URL =
  'https://help.shine.fr/fr/articles/6309428-comment-modifier-mes-coordonnees-bancaires-pour-mes-prelevements';

interface DirectDebitMandateOldIbanWarningProps {
  hasMoreThanOneDeprecatedMandates?: boolean;
  isB2BMandate?: boolean;
}

const DirectDebitMandateOldIbanWarning: FC<
  DirectDebitMandateOldIbanWarningProps
> = ({ hasMoreThanOneDeprecatedMandates, isB2BMandate }) => {
  const {
    error,
    hasBeenMigratedToEP,
    hasBeenSevenDaysSinceMigrationStarted,
    loading,
    migratedToEPAt,
  } = useGetMigrationToEpData();

  if (loading || error !== undefined || migratedToEPAt == null) {
    return null;
  }

  const estimatedMigrationEndDate =
    getEstimatedEPMigrationEndDate(migratedToEPAt);
  const schemeWarning = isB2BMandate ? locales.b2bWarning : locales.coreWarning;
  const warningText = locales.formatString(
    hasMoreThanOneDeprecatedMandates ? locales.warningMultiple : schemeWarning,
    formatDate(estimatedMigrationEndDate, 'P'),
  ) as string;

  if (
    hasBeenMigratedToEP &&
    hasBeenSevenDaysSinceMigrationStarted &&
    warningText !== null
  ) {
    return (
      <Link
        href={UPDATE_DIRECT_DEBIT_MANDATE_HELP_URL}
        isExternal
        marginBottom="space-16"
      >
        <Callout variant="warning">
          <Callout.Content>{warningText}</Callout.Content>
        </Callout>
      </Link>
    );
  }

  return null;
};

export default DirectDebitMandateOldIbanWarning;
